import { createContext, type ReactNode, useContext, useEffect, useState } from "react"

export enum Theme {
  AthleteLight = "athlete-light",
  CoachLight = "coach-light",
  OwnerDark = "owner-dark",
}

// type ThemeProviderProps = {
//   children: React.ReactNode
//   defaultTheme?: Theme
//   storageKey?: string
// }

type ThemeProviderState = {
  theme: Theme
  setTheme: (theme: Theme) => void
  styles: CSSStyleDeclaration
  getPropertyValue: (property: string) => string
}

const initialState: ThemeProviderState = {
  theme: Theme.AthleteLight,
  setTheme: () => null,
  styles: getComputedStyle(document.documentElement),
  getPropertyValue: (property: string) => {
    return getComputedStyle(document.documentElement).getPropertyValue(property).trim()
  },
}

const ThemeProviderContext = createContext<ThemeProviderState>(initialState)

export function ThemeProvider({ children, initialTheme }: { children: ReactNode; initialTheme?: Theme }) {
  const [activeTheme, setActiveTheme] = useState<Theme>(() => initialTheme || Theme.AthleteLight)
  const [styles, setStyles] = useState<CSSStyleDeclaration>(getComputedStyle(document.documentElement))

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", activeTheme)
  }, [activeTheme])

  const value = {
    theme: activeTheme,
    setTheme: (theme: Theme) => {
      setStyles(getComputedStyle(document.documentElement))
      // localStorage.setItem(storageKey, theme)
      setActiveTheme(theme)
    },
    styles,
    getPropertyValue: (property: string) => {
      return styles.getPropertyValue(property).trim()
    },
  }

  return <ThemeProviderContext.Provider value={value}>{children}</ThemeProviderContext.Provider>
}

export const useTheme = () => {
  const context = useContext(ThemeProviderContext)

  if (context === undefined) throw new Error("useTheme must be used within a ThemeProvider")

  return context
}
